import { render, staticRenderFns } from "./RequestsPending.vue?vue&type=template&id=d3248f5a"
import script from "./RequestsPending.vue?vue&type=script&lang=js"
export * from "./RequestsPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports